/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PasswordValidationRuleName } from './PasswordValidationRuleName';
import {
    PasswordValidationRuleNameFromJSON,
    PasswordValidationRuleNameFromJSONTyped,
    PasswordValidationRuleNameToJSON,
} from './PasswordValidationRuleName';

/**
 * 
 * @export
 * @interface BasePasswordValidationRule
 */
export interface BasePasswordValidationRule {
    /**
     * 
     * @type {PasswordValidationRuleName}
     * @memberof BasePasswordValidationRule
     */
    name: PasswordValidationRuleName;
}

/**
 * Check if a given object implements the BasePasswordValidationRule interface.
 */
export function instanceOfBasePasswordValidationRule(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function BasePasswordValidationRuleFromJSON(json: any): BasePasswordValidationRule {
    return BasePasswordValidationRuleFromJSONTyped(json, false);
}

export function BasePasswordValidationRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): BasePasswordValidationRule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': PasswordValidationRuleNameFromJSON(json['name']),
    };
}

export function BasePasswordValidationRuleToJSON(value?: BasePasswordValidationRule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': PasswordValidationRuleNameToJSON(value.name),
    };
}

